export function initWixRecorder() {
  window.addEventListener('wixRecorderReady', async () => {
    try {
      await window.wixRecorder!.addLabel('marketing-template-viewer');
    } catch (error) {
      console.error(error);
    }
  });
}
